import { useEffect } from "react";

const SITE_NAME = "NYG Projects";
export const SITE_URL = "https://www.nygprojects.com";

function upsert(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Per-route document metadata (title, description, Open Graph, Twitter card).
// Updates the static tags already present in public/index.html instead of
// duplicating them, so social scrapers see a single, correct set per page.
export default function Seo({ title, description, image, path, imageAlt, type = "website" }) {
  useEffect(() => {
    const absImage = `${SITE_URL}${image}`;
    const absUrl = `${SITE_URL}${path}`;

    document.title = title;
    upsert("name", "description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", absUrl);

    upsert("property", "og:type", type);
    upsert("property", "og:site_name", SITE_NAME);
    upsert("property", "og:title", title);
    upsert("property", "og:description", description);
    upsert("property", "og:url", absUrl);
    upsert("property", "og:image", absImage);
    upsert("property", "og:image:secure_url", absImage);
    upsert("property", "og:image:type", "image/jpeg");
    upsert("property", "og:image:width", "1200");
    upsert("property", "og:image:height", "630");
    upsert("property", "og:image:alt", imageAlt || title);

    upsert("name", "twitter:card", "summary_large_image");
    upsert("name", "twitter:title", title);
    upsert("name", "twitter:description", description);
    upsert("name", "twitter:image", absImage);
    upsert("name", "twitter:image:alt", imageAlt || title);
  }, [title, description, image, path, imageAlt, type]);

  return null;
}
